export default __webpack_public_path__ + "static/media/truck_dark.a340c839.png";